import React, { useEffect, useState } from "react";
import {
  getImageUrl,
  GetMatchScores,
  GetTennisMatchStatus,
} from "../../utils/generalLiveCenter";
import NextImage from "../common/NextImage";
import PreMatches from "./PreMatches";
import { loadStyles } from "../../utils/cssLoader";

const TennisInfoTable = ({
  ServerData,
  difference,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  sport = "tennis",
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;
  const matchScore = GetMatchScores(
    data?.commentary?.scores,
    GetTennisMatchStatus(data?.st, data?.cp)
  );

  // Get player image URL - use teamImage utility if headersList is provided


  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("tennismatchinfo");
    }
  }, [loadCSS]);

  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <div className="commentary_tennis">
        <div className="lineupbox">
          <div className="global_table player_sets">
            <table>
              <thead>
                <tr>
                  <th>Sets</th>
                  {(matchScore?.s1away || matchScore?.s1home) && <th>1st</th>}
                  {(matchScore?.s2away || matchScore?.s2home) && <th>2nd</th>}
                  {(matchScore?.s3away || matchScore?.s3home) && <th>3rd</th>}
                  {(matchScore?.s4away || matchScore?.s4home) && <th>4th</th>}
                  {(matchScore?.s5away || matchScore?.s5home) && <th>5th</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="players_inf">
                      <div className="avtar">
                        <NextImage
                          src={getImageUrl('', '', 'tennis', data?.commentary?.competitors?.hpid)}
                          height={18}
                          width={18}
                          alt="homePlayer"
                          priority={false}
                        />
                      </div>
                      <div className="avtar_inf">
                        <strong className="name small">
                          {data?.commentary?.competitors?.htn}
                        </strong>
                      </div>
                    </div>
                  </td>
                  {matchScore?.s1home && (
                    <td>
                      {matchScore?.s1home}
                      <sup>{matchScore?.s1hometb}</sup>
                    </td>
                  )}
                  {matchScore?.s2home && (
                    <td>
                      {matchScore?.s2home}
                      <sup>{matchScore?.s2hometb}</sup>
                    </td>
                  )}
                  {matchScore?.s3home && (
                    <td>
                      {matchScore?.s3home}
                      <sup>{matchScore?.s3hometb}</sup>
                    </td>
                  )}
                  {matchScore?.s4home && (
                    <td>
                      {matchScore?.s4home}
                      <sup>{matchScore?.s4hometb}</sup>
                    </td>
                  )}
                  {matchScore?.s5home && (
                    <td>
                      {matchScore?.s5home}
                      <sup>{matchScore?.s5hometb}</sup>
                    </td>
                  )}
                </tr>
                <tr>
                  <td>
                    <div className="players_inf">
                      <div className="avtar">
                        <NextImage
                          src={getImageUrl('', '', 'tennis', data?.commentary?.competitors?.apid)}
                          height={18}
                          width={18}
                          alt="awayPlayer"
                          priority={false}
                        />
                      </div>
                      <div className="avtar_inf">
                        <strong className="name small">
                          {data?.commentary?.competitors?.atn}
                        </strong>
                      </div>
                    </div>
                  </td>
                  {matchScore?.s1away && (
                    <td>
                      {matchScore?.s1away}
                      <sup>{matchScore?.s1awaytb}</sup>
                    </td>
                  )}
                  {matchScore?.s2away && (
                    <td>
                      {matchScore?.s2away}
                      <sup>{matchScore?.s2awaytb}</sup>
                    </td>
                  )}
                  {matchScore?.s3away && (
                    <td>
                      {matchScore?.s3away}
                      <sup>{matchScore?.s3awaytb}</sup>
                    </td>
                  )}
                  {matchScore?.s4away && (
                    <td>
                      {matchScore?.s4away}
                      <sup>{matchScore?.s4awaytb}</sup>
                    </td>
                  )}
                  {matchScore?.s5away && (
                    <td>
                      {matchScore?.s5away}
                      <sup>{matchScore?.s5awaytb}</sup>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <PreMatches data={data} sport={sport} />
      </div>
    </>
  );
};

export default TennisInfoTable;
